import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedPublishedFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/published/applied_published_filter"]

  removeFilter: (value) ->
    @searchQuery.resetField('fb_is_published')

  getFilterValue: ->
    @searchQuery.get('fb_is_published')